// export const API_URL = 'https://cumulus.onrender.com'
// export const API_URL = 'http://13.60.103.121:3000'
// export const API_URL = 'http://16.170.230.178:3000'
// export const API_URL = 'http://16.170.230.178:3000'
export const API_URL = 'https://api.cumulus.rip'
export const FAPI_URL = 'https://www.cumulus.rip'
// export const API_URL = 'http://localhost:3000'
// export const FAPI_URL = 'http://localhost:3001'
